export default __webpack_public_path__ + "static/media/purpleTerraform.4d1fd278.svg";